<span *ngIf="!picking" (click)="picking = !picking">
  <fa-icon [icon]="['fas', 'language']" title="Select language"></fa-icon>
  {{ cultureService.PreferredCultureName$ | async }}
</span>
<ul *ngIf="picking">
  <li *ngFor="let culture of cultureService.AvailableCultures | keyvalue">
    <fa-icon *ngIf="culture.key == cultureService.PreferredCulture" [icon]="['fas', 'check']" title="Selected"></fa-icon>
    <a (click)="UpdateCulture(culture.key)">{{culture.value}}</a>
  </li>
</ul>